import * as React from 'react'
import dynamic from 'next/dynamic'

import { useTheme } from '@thg-commerce/enterprise-core'
import { SvgIcon } from '@thg-commerce/gravity-icons/src/components/SvgIcon'

import { RefineButton, RefineIconTextWrapper, RefineText } from './styles'

const RefineIcon = dynamic(
  () => import('@thg-commerce/gravity-icons/src/components/RefineIcon'),
  { ssr: true, loading: () => <svg style={{ height: 24, width: 24 }} /> },
)

export interface MobileRefineButtonProps {
  facetsLength: number
  refineText: string
  editRefineText: string
  onRefineClick: () => void
}

export const MobileRefineButton = React.memo<MobileRefineButtonProps>(
  ({ facetsLength, refineText, editRefineText, onRefineClick }) => {
    const theme = useTheme()
    const handleClick = React.useCallback(() => {
      onRefineClick()
    }, [onRefineClick])

    return (
      <RefineButton
        data-testid="mobile-facets-open-button"
        onClick={handleClick}
        emphasis={theme.widget.productList.filterButton.emphasis}
      >
        <RefineIconTextWrapper>
          <RefineText>
            {facetsLength > 0 ? editRefineText : refineText}
          </RefineText>
          {theme.widget.productList.filterButton.icon?.svgPath ? (
            <SvgIcon
              xmlns="http://www.w3.org/2000/svg"
              viewBox={theme.widget.productList.filterButton.icon.viewBox}
              width={theme.widget.productList.filterButton.icon.width}
              height={theme.widget.productList.filterButton.icon.height}
            >
              <path
                d={theme.widget.productList.filterButton.icon.svgPath}
                fillRule="evenodd"
              />
            </SvgIcon>
          ) : (
            <RefineIcon />
          )}
        </RefineIconTextWrapper>
      </RefineButton>
    )
  },
)

MobileRefineButton.displayName = 'MobileRefineButton'
